import { useState } from "react";
import { deepCopy, updateNestedValue } from "../../../../../../common/services/common.service";
import Popup from "../../../../../../common/components/popup";
import ProductSpecificationAttributeOptionBasicInfoComponent from "./settlement-request-item-basic-info.component";
import SettlementRequestItemBasicInfoComponent from "./settlement-request-item-basic-info.component";

export const SettlementRequestItemPopup = ({ 
  selectedSettlementRequestItem,
  selectedParticipant,
  closeModal,
  handleSaveSettlementRequestItem,
}: any) => {
  console.log('selectedSettlementRequestItem', selectedSettlementRequestItem)
    const [localAttribute, setLocalAttribute] = useState(deepCopy(selectedSettlementRequestItem));

    const handleLocalFormChange = ({path, value}: any) => {
      console.log('selectedSettlementRequestItem, path, value', selectedSettlementRequestItem, path, value)
      const updatedData = updateNestedValue(selectedSettlementRequestItem, path, value)
  
      console.log('updatedData', updatedData)
      setLocalAttribute({...updatedData});
    };

    const handleFormSubmit = () => {
      // setSelectedProductSpecificationAttributeItem(localAttribute);
      handleSaveSettlementRequestItem(localAttribute)
    };

    return (
      <>
        <Popup onClose={closeModal}>
          <SettlementRequestItemBasicInfoComponent
            onClose={closeModal}
            handleInnerFormChange={handleLocalFormChange}
            selectedSettlementRequestItem={selectedSettlementRequestItem}
            selectedParticipant={selectedParticipant}
            handleFormSubmit={handleFormSubmit}
          />
        </Popup>
      </>
    )
  }